import { useEffect, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { downloadModel } from 'store/actions/rpcActions';
import { AvailCanvas } from './AvailCanvas';
import {
  clearUpdateData,
  clearSerializedData,
  setGuidURL,
  setReinitializeCanvas,
  setExportModel,
  setExportedModelData,
} from 'store/actions/canvasActions';
import { CanvasContainer } from './styles';
import { ActionArea } from './ActionArea';
import _ from 'lodash';

const Avail = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const canvasStore = useSelector(state => state.canvas);
  const guidURL = useMemo(() => canvasStore.guidURL, [ canvasStore ]);
  const [ isDownloading, setIsDownloading ] = useState(false);

  const guid = pathname.split('avail/')[1];

  const cleanup = useCallback(() => {
    dispatch(clearUpdateData());
    dispatch(clearSerializedData());
    dispatch(setGuidURL(null));
    dispatch(setReinitializeCanvas(false));
    dispatch(setExportModel(false));
    dispatch(setExportedModelData(null));
  }, [ dispatch ]);

  const getDownloadURL = useCallback(() => {
    if (guid && _.isEmpty(guidURL) && !isDownloading) {
      const args = { guid, format: 'DRACO_GLB' };
      setIsDownloading(true);
      dispatch(downloadModel(args));
      return;
    }
  }, [ guid, dispatch, isDownloading, guidURL ]);

  useEffect(() => {
    return () => cleanup();
  }, [ cleanup ]);

  useEffect(() => {
      getDownloadURL();
  }, [ getDownloadURL ]);

  return (
    <CanvasContainer>
      <AvailCanvas previewURL={guidURL}/>
      <ActionArea guidURL={guidURL}/>
    </CanvasContainer>
  );
};

export { Avail };